import { Skeleton } from "@mantine/core";

/**
 * Skeleton that mimics the EventInfoCard layout:
 * hero image, event name, date/time row, location row.
 */
export default function EventCardSkeleton() {
  return (
    <div className="flex flex-col gap-4 p-4 bg-white">
      {/* Hero image */}
      <Skeleton height={200} radius="md" />

      {/* Event name */}
      <Skeleton height={24} width="70%" radius="sm" />

      {/* Date row */}
      <div className="flex items-center gap-2">
        <Skeleton height={20} width={20} circle />
        <Skeleton height={16} width="50%" radius="sm" />
      </div>

      {/* Location row */}
      <div className="flex items-center gap-2">
        <Skeleton height={20} width={20} circle />
        <Skeleton height={16} width="60%" radius="sm" />
      </div>
    </div>
  );
}
